import styles from "./SectionHeader.module.css";

// Green mono section label with an optional right-hand slot (link or meta text)
export default function SectionHeader({ title, aside }) {
  return (
    <div className={`${styles.header} d-flex align-items-center justify-content-between`}>
      <h2 className={`${styles.title} label-font`}>{title}</h2>
      {aside}
    </div>
  );
}
